<template>
  <wrap-container>
    <h1 class="titulo titulo--principal p32">
      <span class="oscuro medium">Escribinos tu consulta</span><br />
      <span> y te responderemos a la brevedad </span>
    </h1>
    <formulario-contacto />
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  name: "TipoConsulta",
  components: {
    WrapContainer,
    FormularioContacto
  }
};
</script>

<style scoped></style>
